import { defineStore } from 'pinia';

interface NumberOfAppliedFilters {
  numberOfFilters: number;
}

export const useFilterStore = defineStore('filters', {
  state: (): NumberOfAppliedFilters => ({
    numberOfFilters: 0,
  }),
  actions: {
    updateNumber(filtersArray: any[]) {
      this.numberOfFilters = filtersArray.length;
    },
  },
});
